import { Component, DoCheck, Input, KeyValueDiffer, KeyValueDiffers } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DeviceInformation } from '../shared/models/device-information';
import { IDeviceCategory, IDeviceNode } from '../shared/models/device';

/**
 * Recursive component used to render a grouping of device categories, sections and input controls.
 */
@Component({
    selector: 'dl-device-grouping',
    templateUrl: './device-grouping.component.html',
    styleUrls: ['./device-grouping.component.scss']
})
export class DeviceGroupingComponent implements DoCheck {
    public static $name: string = 'deviceGrouping';

    @Input() public deviceInfo: IDeviceNode; // this will normally come from 'grouping' but can be overridden using this
    @Input() public deviceInputForm: FormGroup; // Recurse ONLY!
    @Input() public grouping: any;
    @Input() public ngForm: FormGroup; // Base ONLY!
    @Input() public setDeviceInfo: (deviceInfo: DeviceInformation) => void;

    public categories: IDeviceCategory[];
    private differ: KeyValueDiffer<string, any>;

    public constructor(private differs: KeyValueDiffers) {
        this.differ = this.differs.find({}).create();
    }

    public ngDoCheck(): void {
        const groupingChange = this.differ.diff(this.grouping);
        const categoryChange = this.grouping !== undefined && this.differ.diff(this.grouping.$categories);
        const change = groupingChange || categoryChange;
        if (change && this.grouping && this.grouping.$categories) {
            this.categories = this.grouping.$categories.filter(category => category.isVisible)
                .sort((a, b) => a.order - b.order)
                .map(category => {
                    const extended = {...category, form: this.deviceInputForm.controls[category.categoryName] || new FormGroup({})};
                    if (this.ngForm) {
                        this.ngForm.addControl(category.categoryName, extended.form);
                    } else {
                        this.deviceInputForm.addControl(category.categoryName, extended.form);
                    }
                    return extended;
                });
        }
    }

    public getInputs(inputs: Array<{ order: number}>) {
        return inputs.sort((a, b) => a.order - b.order);
    }

    public trackByCategoryName(index: number, category: IDeviceCategory) {
        return category.categoryName;
    }
}
